export default __webpack_public_path__ + "static/media/javascriptLogo.fc406b47.svg";